<template>
  <div class="">

    <div class="container">
      <form @submit.prevent="submit">


        <form-group :validations="$v.form.store_location" class="w-100">
          <div slot-scope="{ errors, invalid }">

            <div class="form-group">
              <label for="store-location">مکان فروشگاه</label>
              <input readonly v-model="form.store_location" type="text" class="form-control" id="store-location">
            </div>

            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>

        <l-map style="height: 300px" :zoom="zoom" :center="center" @click="onMapClick">
          <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
          <l-marker :lat-lng="markerPosition" :icon="customIcon"></l-marker>
        </l-map>


        <div class="col-8 my-3 mx-auto">
          <div class="btn btn-secondary  " @click="addNewItem" type="button">
            <span class="mx-1">افزودن دامنه</span>
            <b-icon icon="plus-circle-fill" class="mb-1"/>
          </div>

          <div class="form-row align-items-center" v-for="(range,index) in form.ranges">
            <div class="form-group mx-2">
              <label>شروع دامنه</label>
              <input v-model="range['start']" required type="text" class="form-control">
            </div>

            <div class="form-group mx-2">
              <label>پایان دامنه</label>
              <input v-model="range['end']" type="text" class="form-control">
            </div>

            <div class="form-group mx-2">
              <label>قیمت</label>
              <input v-model="range['price']" type="text" class="form-control">
            </div>

            <div class="form-group mx-2">
              <b-icon class="mt-4" @click="deleteItem(index)" icon="trash-fill"/>
            </div>


          </div>


        </div>


        <div class="col-12 text-center">
          <button type="submit" class="btn w-25 btn-primary rounded-pill">ثبت</button>
        </div>
      </form>
    </div>


  </div>
</template>

<script>
import FormGroup from "../../validator/FormGroup.vue";
import FormErrorsManager from "../../validator/FormErrorsManager.vue";
import {numeric, required} from "vuelidate/lib/validators";
import 'leaflet/dist/leaflet.css';
import {LMap, LTileLayer, LMarker} from 'vue2-leaflet';
import L from "leaflet";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

export default {
  name: "DeliveryPriceBaseOnLocation",
  components: {
    FormGroup,
    FormErrorsManager,
    LMap,
    LTileLayer,
    LMarker,
  },
  data() {
    return {
      form: {
        store_location: '',
        ranges: []
      },
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
          '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 6, // Zoom level for the map
      center: [32.4279, 53.6880], // Coordinates of Iran
      markerPosition: [32.4279, 53.6880], // Marker coordinates
      customIcon: new L.Icon({
        iconUrl: "/map_icon.png", // Path to your custom marker icon
        iconSize: [60, 60], // Size of the icon
        iconAnchor: [16, 32], // Point of the icon that will correspond to the marker's location
        popupAnchor: [0, -32], // Position of the popup
      }),

    }
  },
  validations: {
    form: {
      store_location: {required},
      ranges: {required},
    },
  },
  methods: {
    formatNumber,
    onMapClick(event) {
      const latLng = event.latlng;
      this.form.store_location = `${latLng.lat},${latLng.lng}`; // Set marker position to clicked coordinates
      this.markerPosition = [latLng.lat, latLng.lng]; // Set marker position to clicked coordinates
    },
    addNewItem() {
      this.form.ranges.push({'start': null, 'end': null, 'price': null})
    },
    deleteItem(index) {
      this.form.ranges.splice(index, 1)
    },
    async getConfig() {
      let request = await this.$store.dispatch('Delivery/getDeliveryBaseOnLocationConfig')
      let response = request.data.data
      if (!Array.isArray(response)) {

        this.form = JSON.parse(response.value)
        this.markerPosition = this.form.store_location.split(',')

      }

    },
    submit() {
      console.log(this.form)

      let form = {
        delivery_price_store_range: JSON.stringify(this.form)
      }

      this.$store.dispatch('Delivery/updateDeliveryBaseOnLocationConfig', form).then(res => {
        toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد')
      })

    }

  },
  mounted() {
    this.getConfig()
  }
}
</script>


<style scoped>

</style>